<template>
  <div>
    <my-head></my-head>
    <div class="pudong-patent minH">
      <div class="crumbs">
        首页 > 交易服务 >
        <span style="color: #1d2129">浦东新区专利公开实施线上平台</span>
      </div>

      <div class="title">浦东新区专利公开实施线上平台</div>
      <div class="lead">
        上海知识产权交易中心建设运营，提供专利估值、信息展示、供需撮合、合同签署和备案管理等全流程服务，试运行期间免收平台服务费。
      </div>

      <a
        class="banner"
        href="https://www.sinoip.net/front/store/shop?storeId=szzl055"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="../assets/pudong-patent-banner.png" alt="浦东新区专利公开实施线上平台" />
        <div class="banner-cap">浦东新区专利公开实施线上平台-专利展示专区（点击进入）</div>
      </a>

      <div class="section-title">平台介绍</div>
      <div class="content">
        为贯彻落实《浦东新区促进知识产权运用若干规定》，加快推动高校、医院、科研院所和国资企业的专利成果向现实生产力转化，上海知识产权交易中心建设运营本线上平台。
        <br /><br />
        专利公开实施，是指专利权人通过本平台以公告方式向社会公开其愿意许可、转让或作价入股的专利及交易条件，由有意向的企业在线申请对接。平台提供专利估值、信息展示、供需撮合、合同签署和备案管理等全流程服务，试运行期间免收平台服务费。
        <br /><br />
        参与平台的创新主体，请先阅读《操作细则》了解制度规则和办理流程，再填写《专利批量上线信息申请表》提交挂牌申请。平台将在收到申请后 5 个工作日内完成形式审查并安排挂牌公示。
      </div>

      <div class="section-title">联系方式</div>
      <div class="contact-card">
        <div class="contact-label">挂牌申请与业务咨询</div>
        <div class="contact-person">
          <div class="contact-avatar">
            <i class="el-icon-phone-outline"></i>
          </div>
          <div>
            <div class="role">业务咨询</div>
            <div class="name">李老师</div>
            <a class="phone" href="tel:17621732167">176 2173 2167</a>
          </div>
        </div>
      </div>

      <div class="policy">
        <div class="policy-title">相关政策：</div>
        <div class="policy-list">
          <a
            v-for="item in policyFiles"
            :key="item.name"
            class="policy-file"
            :href="item.url || undefined"
            :target="item.url ? '_blank' : undefined"
            :rel="item.url ? 'noopener noreferrer' : undefined"
          >{{ item.name }}</a>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
export default {
  name: "pudongPatent",
  components: { MyHead, MyFooter },
  data() {
    return {
      policyFiles: [
        {
          name: "附件一：专利公开实施申请表",
          url: "https://www.shsipe.com/property-upload/2026-09-07/zlgksssqb.docx",
        },
        {
          name: "附件二：浦东新区专利公开实施操作细则",
          url: "https://www.shsipe.com/property-upload/2026-09-07/pdxqzlgkssczxz.doc",
        },
      ],
    };
  },
  created() {
    document.title = "浦东新区专利公开实施线上平台";
  },
};
</script>

<style lang="scss">
.pudong-patent {
  width: 80%;
  margin: 24px auto 60px;

  .title {
    font-size: 30px;
    margin-bottom: 16px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }

  .lead {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
    margin-bottom: 32px;
  }

  .banner {
    display: block;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 12px;
    padding: 40px 24px 32px;
    text-align: center;
    margin-bottom: 48px;
    text-decoration: none;
    cursor: pointer;

    img {
      width: 180px;
      height: auto;
      margin: 0 auto 20px;
    }

    &:hover {
      border-color: #165dff;

      .banner-cap {
        color: #165dff;
      }
    }
  }

  .banner-cap {
    font-size: 16px;
    font-weight: bold;
    color: #1d2129;
    line-height: 24px;
  }

  .section-title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }

  .content {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
    margin-bottom: 48px;
  }

  .contact-card {
    background: #f7f8fa;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    padding: 24px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 48px;
  }

  .contact-label {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    line-height: 24px;
  }

  .contact-person {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .contact-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e8f3ff;
    color: #165dff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .contact-person .role {
    font-size: 12px;
    color: #86909c;
    line-height: 20px;
  }

  .contact-person .name {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    line-height: 24px;
  }

  .contact-person a.phone {
    display: block;
    font-size: 14px;
    color: #165dff;
    text-decoration: none;
    margin-top: 2px;
  }

  .contact-person a.phone:hover {
    text-decoration: underline;
  }

  .policy {
    font-size: 14px;
    color: #1d2129;
    line-height: 28px;
  }

  .policy-title {
    font-weight: 500;
    margin-bottom: 4px;
  }

  .policy-list {
    padding-left: 4em;
  }

  .policy-file {
    display: block;
    color: #1d2129;
    text-decoration: none;
    cursor: default;
  }

  .policy-file[href] {
    color: #165dff;
    cursor: pointer;
  }

  .policy-file[href]:hover {
    text-decoration: underline;
  }
}
</style>
